import { DatePipe } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { FamilyDTO } from 'src/app/demo/model/FamilyDTO';
import { InvoiceDTO } from 'src/app/demo/model/InvoiceDTO';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { TransactionDTO } from 'src/app/demo/model/TransactionDTO';
import { ForteCheckoutService } from 'src/app/demo/service/ForteCheckoutService.service';
import { LocalOperationService } from 'src/app/demo/service/localOperation.service';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { RefundService, RefundTransactionDTO } from 'src/app/demo/service/refund.service';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
import { Common } from 'src/app/demo/utils/common';

@Component({
    selector: 'app-receive-payment',
    templateUrl: './receive-payment.component.html',
    styleUrls: ['./receive-payment.component.scss'],
})
export class ReceivePaymentComponent implements OnInit {
    invoiceData: DynamicDialogConfig<any>;
    invoiceForm: InvoiceDTO;
    receivePmtFrom!: FormGroup;
    submitForm: boolean = false;
    paymentModeList: MasterLookupDTO[] = [];
    transaction!: TransactionDTO;
    optionalDateControl: boolean = false;
    openBalanceAmount: number = 0;
    selectedStudentList: StudentDTO[] = [];
    multiFamily: FamilyDTO[] = [];
    multiFamilyDataList: any;
    multifamilyChilds!: any;
    // selectedFamily!: FamilyDTO;
    selectedFamily: any = {};
    private familySubscription!: Subscription;
    invoices: any;
    studentId: any;
    studentDetails: any;
    balanceAmount!: number;
    allFamPaymentObj: any;
    viewType: any;
    isMultiFmaily: boolean = false;
    multiFamilyStudentList: StudentDTO[] = [];
    backgroundColors: string[] = [];
    maxRefundAmount: number = 0;
    
    // Sibling refund data
    siblingRefundData: Array<{
        studentId: number;
        studentName: string;
        profileimg?: string;
        maxRefundAmount: number;
        refundAmount: number;
        originalPaidAmount: number; // Original payment amount for this sibling
    }> = [];
    hasSiblings: boolean = false;
    
    // Refund validation data - map of transaction ID to amount
    refundTransactions: Map<number, number> = new Map();
    totalRefundableAmount: number = 0;
    isLoadingRefundData: boolean = false;
    
    // Cache full transaction details to avoid redundant API calls
    cachedFullTransactions: Map<number, TransactionDTO> = new Map();
    
    // New properties for receive payment method
    receiveMethod: 'max' | 'custom' = 'max';
    
    // Sibling payment data for regular payments
    siblingPaymentData: Array<{
        studentId: number;
        studentName: string;
        profileimg?: string;
        unpaidAmount: number;
        paymentAmount: number;
        totalAmountInvoiced: number; // Total invoiced amount - used for validation
    }> = [];

    constructor(
        public config: DynamicDialogConfig,
        private formBuilder: FormBuilder,
        public dialogService: DialogService,
        public ref: DynamicDialogRef,
        private lookupService: LookupService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
        private operationService: OperationService,
        private datePipe: DatePipe,
        private localOperationService: LocalOperationService,
        private forteservice: ForteCheckoutService,
        private refundService: RefundService
    ) {
        this.invoiceData = this.config;
        this.invoices = this.config.data.invoiceObj;
        this.viewType = this.config.data.view;
        this.balanceAmount = Math.abs(this.invoiceData.data.balance);
        this.allFamPaymentObj = this.invoiceData.data.paymentObj;
        if (this.viewType == 'AllFamily') {
            this.invoices = this.config.data.invoiceObj?.[0];
        } else {
            // this.invoices = this.config.data.invoiceObj;
        }
        this.openBalanceAmount = this.invoiceData.data.openBalanceAmount;
        if (this.invoiceData.data.isCreate) {
            this.transaction = {};
        } else {
            this.transaction =
                this.invoiceData.data?.invoiceObj?.transactions[0] || {};
        }

        this.invoiceForm = this.config.data.invoiceObj[0]?.invoice[0] || {};
        this.studentId = this.invoiceForm.studentId;
        if (!this.studentId) {
            this.studentId = this.invoiceData.data.invoiceObj[0].id;
        }

        this.multiFamily = this.invoiceData.data.multiFamilyList;

        this.isMultiFmaily = this.invoiceData.data.isMultiFmaily;
        if (this.isMultiFmaily) {
            this.transaction = this.invoiceData.data?.paymentObj;
        }

        this.backgroundColors = profielBackgroundColor;
        
        // Check if siblings exist for both refund and regular payment
        if (this.config.data.siblings && Array.isArray(this.config.data.siblings)) {
            
            // Get validation data passed from parent component
            const siblingValidationData = this.config.data.siblingValidationData || [];
            
            // Initialize sibling payment data structure for ALL children
            this.siblingPaymentData = this.config.data.siblings.map((sibling: any) => {
                // Find validation data for this sibling
                const validationInfo = siblingValidationData.find(
                    (v: any) => v.studentId === sibling.id
                );
                
                return {
                    studentId: sibling.id,
                    studentName: sibling.fullName,
                    profileimg: sibling.profileimg,
                    unpaidAmount: validationInfo?.unpaidAmount || 0, // Use from validation data if available
                    paymentAmount: 0,
                    totalAmountInvoiced: validationInfo?.totalAmountInvoiced || 0 // Store for validation
                };
            });
            
            // Only show sibling UI if there are MORE than 1 child
            if (this.config.data.siblings.length > 1) {
                this.hasSiblings = true;
            } else {
            }
        } else {
        }
    }

    ngOnInit(): void {
        this.queryPaymentMode();
        this.receivePmtFrom = this.formBuilder.group({
            id: undefined,
            transactionType: ['Payment'],
            date: Common.momentCurrentDate(),
            endDate: undefined,
            amount: [Math.abs(this.balanceAmount), [Validators.required]],
            receivedAmount: undefined,
            balance: undefined,
            processStatus: ['Success'],
            description: [undefined],
            paymentMode: [undefined, [Validators.required]],
            chequeNumber: [undefined],
            note: undefined,
            selectedFamily: undefined,
            isLedgerTransaction: [false],
            isSendEmail: [true],
            refTable: ['Invoice'],
            refTableId: this.invoiceForm.id,
            students: undefined,
            schoolId: this.invoiceForm.schoolId,
            status: ['A'],
            receiveMethod: ['max'], // Add receive method control
        });

        if (this.transaction?.id !== undefined) {
            this.receivePmtFrom.patchValue({
                id: this.transaction.id,
                transactionType: this.transaction.transactionType,
                date: Common.momentCurrentDate(),
                endDate: this.transaction.endDate,
                amount: Math.abs(this.transaction.amount ?? 0),
                receivedAmount: this.transaction.recievedAmount,
                balance: this.transaction.balance,
                processStatus: this.transaction.processStatus,
                description: '',
                paymentMode: this.transaction.paymentMode,
                chequeNumber: this.transaction.chequeNumber,
                note: '',
                isLedgerTransaction: this.transaction.isLedgerTransaction,
                isSendEmail: this.transaction.isSendEmail,
                refTable: this.transaction.refTable,
                refTableId: this.transaction.refTableId,
                students: undefined,
                schoolId: this.transaction.schoolId,
                status: this.transaction.status,
            });

            if (this.receivePmtFrom.get('paymentMode')?.value == 'Cheque') {
                this.optionalDateControl = true;
                this.receivePmtFrom.patchValue({
                    chequeNumber: undefined,
                    description: undefined,
                });
            } else {
                this.optionalDateControl = false;
            }
        }

        // if (this.config.data.isRefund) {
        //     this.receivePmtFrom.get('amount')?.disable();
        // }

        if (this.transaction?.id == undefined || this.config.data.isRefund) {
            this.receivePmtFrom
                .get('paymentMode')
                ?.valueChanges.subscribe((paymentMode) => {
                    const chequeNumberControl =
                        this.receivePmtFrom.get('chequeNumber');
                    chequeNumberControl?.clearValidators();
                    if (paymentMode == 'Cheque') {
                        chequeNumberControl?.setValidators([
                            Validators.required,
                        ]);
                        this.optionalDateControl = true;
                    } else {
                        this.optionalDateControl = false;
                        chequeNumberControl?.reset();
                    }
                    chequeNumberControl?.updateValueAndValidity();
                });
        } else if (!this.config.data.isRefund) {
            this.receivePmtFrom.get('paymentMode')?.disable();
        }
        if (this.isMultiFmaily) {
            this.multiFamilyData();
        }

         if (this.config.data.isRefund) {
            // Load refund transaction data (validation already done in parent if skipRefundValidation is true)
            this.loadRefundTransactionData();
            
            // For single child refund
            if (!this.hasSiblings) {
                this.fetchNetPaidAmount().then((netPaid) => {
                    this.receivePmtFrom.get('amount')?.updateValueAndValidity();
                });
            }
            // For sibling refund, no amount field validation needed (handled per sibling)
        } else {
            // Regular payment flow
            // If we have sibling data (even for single child), load unpaid amounts
            if (this.siblingPaymentData.length > 0) {
                // Load unpaid amounts for all students
                this.loadSiblingUnpaidAmounts().then(() => {
                    
                    // If multiple siblings, show sibling UI and set receive method
                    if (this.hasSiblings) {
                        this.onReceiveMethodChange('max');
                    } else {
                        // Single child - use the first sibling's data
                        this.balanceAmount = this.siblingPaymentData[0].unpaidAmount;
                        
                        this.receivePmtFrom.patchValue({
                            amount: this.siblingPaymentData[0].unpaidAmount
                        });

                        // Set validators - no max limit for custom payments
                        this.receivePmtFrom.get('amount')?.setValidators([
                            Validators.required,
                            Validators.min(0.01)
                        ]);
                        this.receivePmtFrom.get('amount')?.updateValueAndValidity();
                    }
                });
            } else {
                // Fallback to old method if no sibling data
                this.fetchUnpaidAmount().then((unpaidAmount) => {
                    this.balanceAmount = unpaidAmount;
                    
                    this.receivePmtFrom.patchValue({
                        amount: unpaidAmount
                    });

                    // Set validators - no max limit for custom payments
                    this.receivePmtFrom.get('amount')?.setValidators([
                        Validators.required,
                        Validators.min(0.01)
                    ]);
                    this.receivePmtFrom.get('amount')?.updateValueAndValidity();
                });
            }
        }

        this.lookupService
            .getStudentById(this.studentId)
            .subscribe((res: HttpResponse<StudentDTO>) => {
                this.studentDetails = res.body ?? {};
            });
    }

     getTotalMaxRefundAmount(): number {
        return this.siblingRefundData.reduce((sum, sibling) => sum + (sibling.maxRefundAmount || 0), 0);
    }

    queryPaymentMode() {
        const statusSearchParams = {
            sort: 'name,asc',
            'type.equals': 'Payment Mode',
        };
        this.lookupService
            .queryMasterLookups(statusSearchParams)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.paymentModeList = res.body ? res.body : temp;
            // For refunds, filter based on original payment type
            if (this.config.data.isRefund) {
                const originalPaymentMode = this.config.data.paymentObj?.paymentMode?.toLowerCase();
                
                const onlineModes = ['mast', 'echeck', 'visa', 'discover','online'];
                if (!onlineModes.includes(originalPaymentMode)) {
                    this.paymentModeList = this.paymentModeList.filter(
                        (mode) => mode.value?.toLowerCase() !== 'online'
                    );
                } else {
                    // Pre-select "Online" for these card types
                    const onlineOption = this.paymentModeList.find(
                        (mode) => mode.value?.toLowerCase() === 'online'
                    );
                    if (onlineOption) {
                        this.receivePmtFrom.get('paymentMode')?.setValue(onlineOption.value);
                    }
                }
                // If original payment IS online, show all options (no filtering)
            } else if (this.invoiceData.data.hideOnlinePayment) {
                // Hide "Online" only if hideOnlinePayment flag is set (for regular payments)
                this.paymentModeList = this.paymentModeList.filter(
                    (mode) => mode.value?.toLowerCase() !== 'online'
                );
            }
            });
    }


    async fetchNetPaidAmount(): Promise<number> {
    try {
        // Get primary student ID (not siblings)
        const primaryStudentId = this.config.data.paymentObj?.studentId || this.studentId;
        
        const queryParams = {
            'studentId.in': primaryStudentId,
            'sort': 'id,desc',
            'page': 0,
            'size': 500
        };

        const response = await this.lookupService.queryAllInvoiceCount(queryParams).toPromise();
        
            if (response && response.body) {
                // Get netAmountPaid from the response
                const netPaid = response.body.netAmountPaid || 0;
                return Math.abs(netPaid);
            }
                return 0;
        } catch (error) {
            console.error('Error fetching net paid amount:', error);
            return 0;
        }
    }

    async fetchUnpaidAmount(): Promise<number> {
        try {
            // Get primary student ID (not siblings)
            const primaryStudentId = this.studentId;
            
            const queryParams = {
                'studentId.in': primaryStudentId,
                'sort': 'id,desc',
                'page': 0,
                'size': 500
            };

            const response = await this.lookupService.queryAllInvoiceCount(queryParams).toPromise();
            
            if (response && response.body) {
                // Get unpaid amount from the response (keep negative if overpaid)
                const unpaidAmount = response.body.amountUnpaid || 0;
                return unpaidAmount;
            }
            return 0;
        } catch (error) {
            console.error('Error fetching unpaid amount:', error);
            return 0;
        }
    }

    /**
     * Load refund transaction data for validation
     * Data is passed from parent component to avoid duplicate API calls
     */
    loadRefundTransactionData(): void {
        // Get refund transactions data passed from parent component
        const refundTransactionsData = this.config.data.refundTransactionsData;
        
        if (!refundTransactionsData) {
            console.error('No refund transactions data provided');
            return;
        }
        
        // Use the data passed from parent component (no API call needed)
        this.isLoadingRefundData = false;
        
        // Convert response object to Map
        this.refundTransactions.clear();
        let totalAvailableAmount = 0;
        
        for (const [txnId, amount] of Object.entries(refundTransactionsData)) {
            this.refundTransactions.set(Number(txnId), Number(amount));
            totalAvailableAmount += Number(amount);
        }
        
        // Check if single or multiple transaction IDs
        if (this.refundTransactions.size === 1) {
            this.handleSingleTransactionRefund();
        } else {
            this.handleMultipleTransactionRefund();
        }
    }

    /**
     * Handle single transaction refund (current paid student = payment student)
     */
    private handleSingleTransactionRefund(): void {
        // Calculate total refundable amount from Map
        this.totalRefundableAmount = 0;
        for (const [txnId, amount] of this.refundTransactions.entries()) {
            this.totalRefundableAmount += amount;
        }
        
        // Update max refund amount
        this.maxRefundAmount = this.totalRefundableAmount;
        
        // Update form validation based on refundable amount
        this.receivePmtFrom.get('amount')?.setValidators([
            Validators.required,
            Validators.max(this.totalRefundableAmount),
            Validators.min(0.01)
        ]);
        this.receivePmtFrom.patchValue({
            amount: this.totalRefundableAmount
        });
        this.receivePmtFrom.get('amount')?.updateValueAndValidity();
        
        // Keep hasSiblings as false for single transaction
        this.hasSiblings = false;
    }

    /**
     * Handle multiple transaction refund (multiple students involved)
     */
    private handleMultipleTransactionRefund(): void {
        this.hasSiblings = true;
        this.siblingRefundData = [];
        
        
        // Create array of observables to fetch transaction details
        const transactionFetches = Array.from(this.refundTransactions.entries()).map(([txnId, amount]) => {
            
            return this.lookupService.queryAllTransaction({
                'id.equals': txnId,
                'sort': 'id,desc',
                'page': 0,
                'size': 1
            }).toPromise().then(response => ({ txnId, amount, response }));
        });
        
        // Fetch all transaction details in parallel
        Promise.all(transactionFetches).then(results => {
            
            results.forEach(({ txnId, amount, response }) => {
                if (response?.body?.[0]) {
                    const transaction = response.body[0];
                    
                    
                    // Cache the full transaction for later use
                    this.cachedFullTransactions.set(transaction.id, transaction);
                    
                    // Get student details from transaction
                    if (transaction.students?.[0]) {
                        const student = transaction.students[0];

                        
                        // Add to sibling refund data
                        this.siblingRefundData.push({
                            studentId: student.id || 0,
                            studentName: student.fullName || 'Unknown Student',
                            profileimg: student.profileimg,
                            maxRefundAmount: Math.abs(amount),
                            refundAmount: Math.abs(amount), // Pre-fill with max amount
                            originalPaidAmount: Math.abs(transaction.amount || 0) // Original payment amount
                        });
                    }
                }
            });
            
            
            // Calculate total max refund amount
            this.totalRefundableAmount = this.siblingRefundData.reduce(
                (sum, sibling) => sum + (sibling.maxRefundAmount || 0), 
                0
            );
            this.maxRefundAmount = this.totalRefundableAmount;
            
        }).catch(error => {
            console.error('Error fetching transaction details:', error);
            this.messageService.add({
                severity: 'error',
                life: 3000,
                summary: 'Error',
                detail: 'Failed to load transaction details. Please try again.',
            });
        });
    }

    /**
     * Returns short device info for lastModifiedPlatformDescription, e.g. "Chrome [Windows]"
    */
    getDeviceDetails(): string {
        const userAgent = navigator.userAgent;

        // Browser detection (with version)
        let browser = 'Unknown';
        if (/Chrome\/([0-9.]+)/.test(userAgent) && userAgent.indexOf('Edge') === -1 && userAgent.indexOf('OPR') === -1) {
            browser = 'Chrome';
        } else if (/Safari\/([0-9.]+)/.test(userAgent) && userAgent.indexOf('Chrome') === -1) {
            browser = 'Safari';
        } else if (/Firefox\/([0-9.]+)/.test(userAgent)) {
            browser = 'Firefox';
        } else if (/Edge\/([0-9.]+)/.test(userAgent)) {
            browser = 'Edge';
        } else if (/OPR\/([0-9.]+)/.test(userAgent) || /Opera\/([0-9.]+)/.test(userAgent)) {
            browser = 'Opera';
        } else if (/Trident\/.*rv:([0-9.]+)/.test(userAgent)) {
            browser = 'Internet Explorer';
        }

        // OS detection (with version)
        let os = 'Unknown';
        let osVersion = '';
        if (/Windows NT ([0-9.]+)/.test(userAgent)) {
            os = 'Windows';
            osVersion = userAgent.match(/Windows NT ([0-9.]+)/)?.[1] || '';
        } else if (/Mac OS X ([0-9_]+)/.test(userAgent)) {
            os = 'MacOS';
            osVersion = userAgent.match(/Mac OS X ([0-9_]+)/)?.[1].replace(/_/g, '.') || '';
        } else if (/Android ([0-9.]+)/.test(userAgent)) {
            os = 'Android';
            osVersion = userAgent.match(/Android ([0-9.]+)/)?.[1] || '';
        } else if (/iPhone OS ([0-9_]+)/.test(userAgent)) {
            os = 'iOS';
            osVersion = userAgent.match(/iPhone OS ([0-9_]+)/)?.[1].replace(/_/g, '.') || '';
        } else if (/Linux/.test(userAgent)) {
            os = 'Linux';
        }

        // Example: Chrome 114.0.0.0 [Windows 10.0]
        return `${browser} [${os}${osVersion ? ' ' + osVersion : ''}]`;
    }
    /**
     * Validate refund amount against available transactions
     */
    validateRefundAmount(refundAmount: number): boolean {
        if (refundAmount <= 0) {
            return false;
        }
        
        if (refundAmount > this.totalRefundableAmount) {
            return false;
        }
        
        return true;
    }

    /**
     * Get refund validation error message
     */
    getRefundValidationError(): string {
        const amount = this.receivePmtFrom.get('amount')?.value || 0;
        
        if (amount <= 0) {
            return 'Refund amount must be greater than 0';
        }
        
        if (amount > this.totalRefundableAmount) {
            return `Refund amount cannot exceed $${this.totalRefundableAmount.toFixed(2)}`;
        }
        
        return '';
    }
    
    onSubmit() {
        // Guard: Prevent execution if payment is invalid or already submitting
        if (this.submitForm || !this.isPaymentValid()) {
            return;
        }

        // Validate form first
        if (!this.receivePmtFrom.valid) {
            this.receivePmtFrom.markAllAsTouched();
            this.submitForm = false;
            return;
        }

        // Additional validation for siblings
        if (this.hasSiblings && this.receiveMethod === 'custom') {
            if (!this.isSiblingPaymentValid()) {
                this.messageService.add({
                    severity: 'error',
                    life: 3000,
                    summary: 'Validation Error',
                    detail: 'Please ensure all payment amounts are valid and at least one has a value.',
                });
                this.submitForm = false;
                return;
            }
        }

        const isUpdate = this.receivePmtFrom.value.id != undefined;
        const serviceMethod = isUpdate ? 'updateTransaction' : 'createTransaction';

        if (this.receivePmtFrom.valid) {
            this.submitForm = true;
            
            // Handle sibling payments - create multiple transactions (both for max and custom)
            if (this.hasSiblings) {
                this.createSiblingTransactions();
                return;
            }
            
            // Single transaction flow
            const formValues = this.receivePmtFrom.value;
            let obj: TransactionDTO = {
                ...formValues,
                description: formValues.description?.trim() || null,
                note: formValues.note?.trim() || null,
                chequeNumber: formValues.chequeNumber?.trim() || null
            };
            
            obj.paymentMode =
                this.receivePmtFrom.controls['paymentMode'].status != 'DISABLED'
                    ? this.receivePmtFrom.get('paymentMode')?.value
                    : this.receivePmtFrom.controls['paymentMode'].value;
            
            let studentIds: any[] = [];
            this.invoiceData.data.invoiceObj.map((each: any) => {
                const keyValue = { id: each.id };
                studentIds.push(keyValue);
            });

            obj.refTableId = this.invoiceForm.id;
            obj.students = [...studentIds];
            obj.familyId = this.receivePmtFrom.get('selectedFamily')?.value;
            
            this.operationService[serviceMethod](obj).subscribe(
                (res: HttpResponse<TransactionDTO>) => {
                    this.submitForm = false;
                    const message = {
                        severity: 'success',
                        life: 3000,
                        summary: 'Success',
                        detail: `Payment ${isUpdate ? 'Updated' : 'Received'} successfully.`,
                    };
                    this.ref.close(message);
                },
                (error: HttpErrorResponse) => {
                    this.submitForm = false;
                    this.messageService.add({
                        severity: 'error',
                        life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
                    });
                }
            );
        }
    }

    /**
     * Create separate transactions for each sibling
     */
    private createSiblingTransactions(): void {
        const formValues = this.receivePmtFrom.value;
        const transactionsToCreate: TransactionDTO[] = [];

        // Determine which siblings to create transactions for based on receiveMethod
        let siblingsWithPayment;
        
        if (this.receiveMethod === 'max') {
            // Current Outstanding - create transaction for each sibling with their full unpaid amount (only if > 0)
            siblingsWithPayment = this.siblingPaymentData.filter(s => (s.unpaidAmount || 0) > 0);
        } else {
            // Custom Amount - create transaction only for siblings with custom payment amount > 0 (regardless of unpaid amount)
            siblingsWithPayment = this.siblingPaymentData.filter(s => (s.paymentAmount || 0) > 0);
        }

        // Create transaction object for each sibling
        siblingsWithPayment.forEach(sibling => {
            // Use unpaidAmount for 'max', paymentAmount for 'custom'
            const amount = this.receiveMethod === 'max' ? sibling.unpaidAmount : sibling.paymentAmount;
            
            const obj: TransactionDTO = {
                transactionType: 'Payment',
                date: formValues.date,
                amount: amount,
                processStatus: 'Success',
                description: formValues.description?.trim() || null,
                paymentMode: formValues.paymentMode,
                chequeNumber: formValues.chequeNumber?.trim() || null,
                note: formValues.note?.trim() || null,
                isLedgerTransaction: formValues.isLedgerTransaction,
                isSendEmail: formValues.isSendEmail,
                refTable: 'Invoice',
                refTableId: this.invoiceForm.id,
                students: [{ id: sibling.studentId }],
                schoolId: this.invoiceForm.schoolId,
                status: 'A',
                familyId: this.receivePmtFrom.get('selectedFamily')?.value
            };
            transactionsToCreate.push(obj);
        });

        // Create all transactions (call API for each)
        let completedCount = 0;
        let hasError = false;

        transactionsToCreate.forEach(transaction => {
            this.operationService.createTransaction(transaction).subscribe(
                (res: HttpResponse<TransactionDTO>) => {
                    completedCount++;
                    if (completedCount === transactionsToCreate.length && !hasError) {
                        this.submitForm = false;
                        const message = {
                            severity: 'success',
                            life: 3000,
                            summary: 'Success',
                            detail: `Payment received successfully for ${completedCount} student(s).`,
                        };
                        this.ref.close(message);
                    }
                },
                (error: HttpErrorResponse) => {
                    hasError = true;
                    this.submitForm = false;
                    this.messageService.add({
                        severity: 'error',
                        life: 3000,
                        summary: error.error?.title || 'Error',
                        detail: error.error?.detail || 'Failed to create transaction.',
                    });
                }
            );
        });
    }

    async onMakeRefund() {
        // Validate based on refund type
        if (this.submitForm) {
            return;
        }
        if (this.hasSiblings) {
            // Sibling refund validation
            if (!this.isSiblingRefundValid()) {
                this.messageService.add({
                    severity: 'error',
                    life: 3000,
                    summary: 'Validation Error',
                    detail: 'Please ensure all refund amounts are valid and payment mode is selected.',
                });
                this.submitForm = false;
                return;
            }
        } else {
            // Single refund validation
            if (!this.receivePmtFrom.valid) {
                this.receivePmtFrom.markAllAsTouched();
                this.submitForm = false;
                return;
            }
            
            const refundAmount = this.receivePmtFrom.get('amount')?.value || 0;
            if (!this.validateRefundAmount(refundAmount)) {
                this.messageService.add({
                    severity: 'error',
                    life: 3000,
                    summary: 'Validation Error',
                    detail: this.getRefundValidationError(),
                });
                this.submitForm = false;
                return;
            }
        }

        this.submitForm = true;

        // Build student IDs array (for the PRIMARY student only in transactionsDTO)
        const primaryStudentId = this.hasSiblings 
            ? this.config.data.invoiceObj[0].id  // Primary student from invoiceObj
            : (this.isMultiFmaily 
                ? this.invoiceData.data?.paymentObj.students[0]?.id 
                : this.invoiceData.data.invoiceObj[0].id);
        
        const studentIds: any[] = [{ id: primaryStudentId }];
        
        // Calculate total refund amount
        const totalRefundAmount = this.hasSiblings 
            ? this.getTotalRefundAmount() 
            : this.receivePmtFrom.get('amount')?.value || 0;
        
        // Build refund distribution and fetch full cancelled transactions
        const { refundDistribution, cancelledTransaction, primaryTransactionId, primaryTransactionAmount } = 
            await this.buildRefundDistribution(totalRefundAmount);
        
        // Get form values and convert empty strings to null
        const formValues = this.receivePmtFrom.value;
        const sanitizedValues = {
            ...formValues,
            description: formValues.description?.trim() || null,
            note: formValues.note?.trim() || null,
            chequeNumber: formValues.chequeNumber?.trim() || null
        };
        
        // Build transaction object - use PRIMARY transaction ID (last one or current student's)
        const obj: TransactionDTO = {
            ...sanitizedValues,
            id: primaryTransactionId,  // Use the primary transaction ID
            amount: primaryTransactionAmount,  // Amount for THIS specific transaction only
            students: studentIds,
            familyId: this.invoiceData.data.paymentObj.familyId,
            processStatus: 'Success',
            transactionType: 'Refund'
        };

        const isOnlinePayment = (this.receivePmtFrom.get('paymentMode')?.value ?? '').toLowerCase() === 'online';

        // Call cancel transaction API
        this.operationService.cancelTransaction(
            obj,
            totalRefundAmount,
            refundDistribution,
            cancelledTransaction
        ).subscribe(
            (res: HttpResponse<TransactionDTO[]>) => {
                this.submitForm = false;

                // Handle online payment gateway refund
                if (isOnlinePayment && res.body && res.body.length > 0) {
                    const firstTransaction = res.body[0];
                    if (firstTransaction.id && firstTransaction.transactionNumber) {
                        const transactionIds = res.body.map(t => t.id).filter(id => id !== undefined) as number[];
                        this.callRefundIdChangesAPI(transactionIds, firstTransaction.transactionNumber);
                    }
                }

                const message = {
                    severity: 'success',
                    life: 3000,
                    summary: 'Success',
                    detail: `Refund successfully credited.`,
                };
                this.ref.close(message);
            },
            (error) => {
                this.submitForm = false;
                this.messageService.add({
                    severity: 'error',
                    life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
                });
            }
        );
    }

    /**
     * Build refund distribution and fetch full cancelled transaction details
     * Returns distribution map, full transaction details, and primary transaction info
     */
    private async buildRefundDistribution(totalRefundAmount: number): Promise<{ 
        refundDistribution: Map<number, number>, 
        cancelledTransaction: TransactionDTO[],
        primaryTransactionId: number,
        primaryTransactionAmount: number
    }> {
        const refundDistribution = new Map<number, number>();
        const cancelledTransaction: TransactionDTO[] = [];
        let primaryTransactionId: number = 0;
        let primaryTransactionAmount: number = 0;
        
        if (this.hasSiblings) {
            // Sibling refund: use custom amounts per sibling, filter out zero amounts
            let transactionIndex = 0;
            const transactionEntries = Array.from(this.refundTransactions.entries());
            
            this.siblingRefundData.forEach((sibling, index) => {
                // Only process if refund amount > 0.01
                if (sibling.refundAmount >= 0.01) {
                    const [transactionId] = transactionEntries[transactionIndex];
                    refundDistribution.set(transactionId, sibling.refundAmount);
                }
                transactionIndex++;
            });
            
            // For siblings, the last NON-ZERO transaction is the primary
            // Find the last sibling with amount > 0.01
            for (let i = this.siblingRefundData.length - 1; i >= 0; i--) {
                if (this.siblingRefundData[i].refundAmount >= 0.01) {
                    const [transactionId] = transactionEntries[i];
                    primaryTransactionId = transactionId;
                    primaryTransactionAmount = this.siblingRefundData[i].refundAmount;
                    break;
                }
            }
        } else {
            // Single refund: use the amount from the form
            const [transactionId, maxAmount] = Array.from(this.refundTransactions.entries())[0];
            const amountToRefund = Math.min(totalRefundAmount, maxAmount);
            
            refundDistribution.set(transactionId, amountToRefund);
            primaryTransactionId = transactionId;
            primaryTransactionAmount = amountToRefund;
        }

        // Fetch full transaction details for each transaction ID and format like transactionsDTO
        for (const [transactionId, refundAmount] of refundDistribution.entries()) {
            // Skip if refund amount is 0 or less than 0.01
            if (refundAmount < 0.01) {
                continue;
            }
            
            try {
                // Check if we already have cached transaction details
                let fullTransaction = this.cachedFullTransactions.get(transactionId);
                
                // If not cached, fetch from API (fallback for single refund flow)
                if (!fullTransaction) {
                    const response = await this.lookupService.queryAllTransaction({
                        'id.equals': transactionId,
                        'sort': 'id,desc',
                        'page': 0,
                        'size': 1
                    }).toPromise();
                    
                    if (response?.body?.[0]) {
                        fullTransaction = response.body[0];
                    }
                } else {
                }
                
                if (fullTransaction) {
                    // Cache it if not already cached
                    if (!this.cachedFullTransactions.has(transactionId)) {
                        this.cachedFullTransactions.set(transactionId, fullTransaction);
                    }
                    
                    
                    // Build student IDs array for this transaction
                    const studentIds = fullTransaction.students?.map((student: any) => ({ id: student.id })) || [];
                    
                    // Get form values and sanitize
                    const description = this.receivePmtFrom.get('description')?.value?.trim() || null;
                    const note = this.receivePmtFrom.get('note')?.value?.trim() || null;
                    const chequeNumber = this.receivePmtFrom.get('chequeNumber')?.value?.trim() || null;
                    
                    // Format transaction like transactionsDTO - only include necessary fields
                    const formattedTransaction: TransactionDTO = {
                        id: fullTransaction.id,
                        transactionType: 'Refund',
                        date: Common.momentCurrentDate(),
                        endDate: fullTransaction.endDate,
                        amount: refundAmount, // Use the refund amount from distribution
                        balance: fullTransaction.balance,
                        processStatus: 'Success',
                        description: description,
                        paymentMode: this.receivePmtFrom.get('paymentMode')?.value || fullTransaction.paymentMode,
                        chequeNumber: chequeNumber,
                        note: note,
                        isLedgerTransaction: false,
                        isSendEmail: undefined,
                        refTable: fullTransaction.refTable || 'Invoice',
                        refTableId: fullTransaction.refTableId,
                        students: studentIds,
                        schoolId: fullTransaction.schoolId || this.invoiceForm.schoolId,
                        status: 'A',
                        familyId: fullTransaction.familyId || this.invoiceData.data.paymentObj?.familyId || null
                    };
                    
                    cancelledTransaction.push(formattedTransaction);
                }
            } catch (error) {
                console.error(`Error fetching transaction ${transactionId}:`, error);
            }
        }

        return { refundDistribution, cancelledTransaction, primaryTransactionId, primaryTransactionAmount };
    }

    private callRefundIdChangesAPI(transactionIds: number[] | number, transactionNumber: any): void {
        // Ensure transactionIds is always an array
        const ids = Array.isArray(transactionIds) ? transactionIds : [transactionIds];
        
        const payload = {
            transactionIds: ids,
            paymentStatus: 'PROCESSING',
            platform: 'WEB', // or use your enum value
            platformDescription: this.getDeviceDetails()
        };
        
        this.forteservice.refundIdChanges(transactionNumber, payload).subscribe(
            (response) => {
                // Success - refund processed through payment gateway
            },
            (error) => {
                // Even if gateway API fails, refund was already credited locally
                console.error('Payment gateway refund processing error:', error);
            }
        );
    }

    updatePayment() {
        let payobj = this.allFamPaymentObj;
        const transactionId = payobj.id;
        payobj.isRefund = true;

        this.subscribeToSaveResponse(
            this.operationService.updateTransaction(payobj)
        );
    }
    protected subscribeToSaveResponse(
        result: Observable<HttpResponse<any>>
    ): void {
        result.subscribe(
            () => this.onSaveSuccess(),
            (error: HttpErrorResponse) => this.onSaveError(error)
        );
    }

    protected onSaveSuccess(): void {
        // this.messageService.add({
        //     severity: 'success',
        //     life: 3000,
        //     summary: 'Success',
        //     detail: `Payment Refunded successfully.`,
        // });
    }
    private onSaveError(error: HttpErrorResponse) {}

    multiFamilyData() {
        this.multiFamilyDataList = this.multiFamily;

        if (this.multiFamilyDataList?.length > 0) {
            this.selectedFamily = this.multiFamilyDataList[0];
            this.receivePmtFrom.patchValue({
                selectedFamily: this.selectedFamily.id,
            });
            this.lookupService
                .queryStudent({
                    size: 30,
                    sort: 'fullName,asc',
                    page: 0,
                    'id.in': this.selectedFamily.childIds,
                })
                .subscribe((res: HttpResponse<StudentDTO[]>) => {
                    this.invoiceData.data.invoiceObj = res.body ? res.body : [];
                    this.multiFamilyStudentList = res.body ?? [];
                });
        }
    }

    onFamilyChange(event: any) {
        const selectedFamilyId = event.value;
        const selectedFamily = this.multiFamilyDataList?.find(
            (each: any) => each.id === selectedFamilyId
        );
        this.lookupService
            .queryStudent({
                size: 30,
                sort: 'fullName,asc',
                page: 0,
                'id.in': selectedFamily.childIds,
            })
            .subscribe((res: HttpResponse<StudentDTO[]>) => {
                this.invoiceData.data.invoiceObj = res.body ? res.body : [];
                this.selectedStudentList = this.invoiceData.data.invoiceObj;
                this.multiFamilyStudentList = res.body ?? [];
            });
    }

    ngAfterContentInit(): void {
        this.familySubscription =
            this.localOperationService.multiFamilyObj.subscribe((family) => {
                // this.multiFamilyDataList = this.multiFamily;
                if (family != null && Object.keys(family).length > 0) {
                    // this.multiFamilyDataList = family;
                    this.receivePmtFrom.patchValue({
                        selectedFamily: family?.id,
                    });
                    this.selectedFamily = family?.id;
                    this.getSelectedFamilyChild(family);
                } else {
                    if (this.multiFamilyDataList?.length > 0) {
                        this.selectedFamily = this.multiFamilyDataList[0];
                        this.receivePmtFrom.patchValue({
                            selectedFamily: this.selectedFamily?.id,
                        });
                        this.getSelectedFamilyChild(this.selectedFamily);
                    }
                }
            });
    }

    ngOnDestroy(): void {
        if (this.familySubscription) {
            this.localOperationService.multifamilyobj(null);
            this.familySubscription.unsubscribe();
            this.localOperationService.multiFamilyBalance(undefined);
        }
    }

    getSelectedFamilyChild(family: any) {
        if (family?.childIds && family?.childIds.length > 0) {
            this.lookupService
                .queryStudent({
                    size: 30,
                    sort: 'fullName,asc',
                    page: 0,
                    'id.in': family?.childIds,
                })
                .subscribe((res: HttpResponse<StudentDTO[]>) => {
                    this.invoiceData.data.invoiceObj = res.body ? res.body : [];
                    // this.selectedStudentList = this.invoiceData.data.invoiceObj;
                });
        }
    }

    getInitials(roomName?: string): string {
        if (!roomName?.trim()) return '';
        const words = roomName.trim().split(/[-\s]+/);
        const firstLetter = words[0]?.[0]?.toUpperCase() || '';
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
    }

    getBackgroundColor(roomId: any) {
        if (!roomId) return this.backgroundColors[0];
        const index = (roomId - 1) % this.backgroundColors.length;
        return this.backgroundColors[index];
    }

    // Validate sibling refund amounts - just update the value without auto-correction
    validateSiblingRefundAmount(index: number, event: any) {
        const sibling = this.siblingRefundData[index];
        let value = 0;
        
        // Handle different event structures
        if (event && typeof event.value !== 'undefined') {
            value = parseFloat(event.value) || 0;
        } else if (event && typeof event.target !== 'undefined' && event.target.value) {
            value = parseFloat(event.target.value) || 0;
        } else {
            value = sibling.refundAmount || 0;
        }
        
        // Just update the value - don't auto-correct
        sibling.refundAmount = value;
        
    }
    
    // Check if a specific sibling refund amount is invalid
    isSiblingRefundInvalid(index: number): boolean {
        const sibling = this.siblingRefundData[index];
        return sibling.refundAmount > sibling.maxRefundAmount || sibling.refundAmount < 0;
    }

    // Get total refund amount for all siblings
    getTotalRefundAmount(): number {
        if (!this.hasSiblings || this.siblingRefundData.length === 0) return 0;
        return this.siblingRefundData.reduce((sum, sibling) => sum + (sibling.refundAmount || 0), 0);
    }

    // Check if sibling refund is valid - simplified logic
    isSiblingRefundValid(): boolean {
        if (!this.hasSiblings) return true;
        
        // Check if at least one sibling has amount > 0
        const hasAmount = this.siblingRefundData.some(s => (s.refundAmount || 0) > 0);
        
        // Check if all amounts are within limits
        const allValid = this.siblingRefundData.every(s => 
            (s.refundAmount || 0) >= 0 && (s.refundAmount || 0) <= s.maxRefundAmount
        );
        
        // Check required form fields (payment mode, description, note)
        const paymentModeValid = this.receivePmtFrom.get('paymentMode')?.valid || false;
        const chequeNumberValid = this.optionalDateControl 
            ? this.receivePmtFrom.get('chequeNumber')?.valid || false
            : true;
        
        return hasAmount && allValid && paymentModeValid && chequeNumberValid;
    }

    // Prevent negative values in the amount field
    // preventNegativeAmount() {
    //     const amountCtrl = this.receivePmtFrom.get('amount');
    //     if (amountCtrl) {
    //         const value = amountCtrl.value;
    //         if (typeof value === 'number' && value < 0) {
    //             amountCtrl.setValue(Math.abs(value));
    //         }
    //     }
    // }

    /**
     * Fetch unpaid amount for a specific student
     */
    async fetchUnpaidAmountForStudent(studentId: number): Promise<{ unpaidAmount: number; totalAmountInvoiced: number }> {
        try {
            const queryParams = {
                'studentId.in': studentId,
                'sort': 'id,desc',
                'page': 0,
                'size': 500
            };
            const res = await this.lookupService.queryAllInvoiceCount(queryParams).toPromise();
            if (res && res.body) {
                const unpaidAmount = res.body.amountUnpaid || 0;
                const totalAmountInvoiced = res.body.totalAmountInvoiced || 0;
                return { unpaidAmount, totalAmountInvoiced };
            }
            return { unpaidAmount: 0, totalAmountInvoiced: 0 };
        } catch (error) {
            console.error('❌ Error fetching unpaid amount for student:', studentId, error);
            return { unpaidAmount: 0, totalAmountInvoiced: 0 };
        }
    }

    /**
     * Load unpaid amounts for all siblings
     * If validation data was already passed from parent, we skip the API call
     */
    async loadSiblingUnpaidAmounts(): Promise<void> {
        if (this.siblingPaymentData.length === 0) {
            return;
        }

        // Check if we already have validation data for ALL siblings
        const hasCompleteValidationData = this.siblingPaymentData.every(
            sibling => sibling.totalAmountInvoiced !== undefined && sibling.unpaidAmount !== undefined
        );

        if (hasCompleteValidationData) {
            // We already have all the data from parent component, no need to fetch again
            return;
        }
    
        // Fallback: Fetch unpaid amount for each sibling that doesn't have data
        for (const sibling of this.siblingPaymentData) {
            // Only fetch if we don't have the data
            if (sibling.unpaidAmount === 0 && sibling.totalAmountInvoiced === 0) {
                const { unpaidAmount, totalAmountInvoiced } = await this.fetchUnpaidAmountForStudent(sibling.studentId);
                sibling.unpaidAmount = unpaidAmount;
                sibling.totalAmountInvoiced = totalAmountInvoiced;
            }
            sibling.paymentAmount = 0; // Initialize to 0
        }

    }

    /**
     * Get total payment amount for siblings
     */
    getTotalSiblingPaymentAmount(): number {
        if (!this.hasSiblings || this.siblingPaymentData.length === 0) return 0;
        return this.siblingPaymentData.reduce((sum, sibling) => sum + (sibling.paymentAmount || 0), 0);
    }

    /**
     * Get total unpaid amount for siblings
     */
    getTotalSiblingUnpaidAmount(): number {
        if (!this.hasSiblings || this.siblingPaymentData.length === 0) return 0;
        return this.siblingPaymentData.reduce((sum, sibling) => sum + (sibling.unpaidAmount || 0), 0);
    }

    /**
     * Validate sibling payment amount
     */
    validateSiblingPaymentAmount(index: number, event: any): void {
        const sibling = this.siblingPaymentData[index];
        let value = 0;
        
        // Handle PrimeNG p-inputNumber event structure
        if (event && typeof event.value !== 'undefined') {
            // onInput event from p-inputNumber
            value = parseFloat(event.value) || 0;
        } else if (event && event.target && typeof event.target.value !== 'undefined') {
            // onBlur event from native input
            value = parseFloat(event.target.value) || 0;
        } else {
            // Fallback to current value
            value = sibling.paymentAmount || 0;
        }
        
        // Update the value
        sibling.paymentAmount = value;
    }

    /**
     * Check if a specific sibling payment amount is invalid
     */
    isSiblingPaymentInvalid(index: number): boolean {
        const sibling = this.siblingPaymentData[index];
        return sibling.paymentAmount < 0; // Only check for negative values
    }

    /**
     * Check if sibling has no invoices (for custom amount validation)
     */
    siblingHasNoInvoices(index: number): boolean {
        const sibling = this.siblingPaymentData[index];
        // Check if payment amount > 0 AND totalAmountInvoiced < 0.01
        return (sibling.paymentAmount > 0) && (sibling.totalAmountInvoiced < 0.01);
    }

    /**
     * Get error message for sibling with no invoices
     */
    getSiblingNoInvoicesError(index: number): string {
        const sibling = this.siblingPaymentData[index];
        return `${sibling.studentName}: Cannot receive payment. No invoices or transactions exist.`;
    }

    /**
     * Check if sibling payment is valid
     */
    isSiblingPaymentValid(): boolean {
        if (!this.hasSiblings) return true;
        
        // Check total payment amount (must be >= 0.01)
        const totalPayment = this.getTotalSiblingPaymentAmount();
        const hasValidAmount = totalPayment >= 0.01;
        
        // Check if all amounts are non-negative
        const allValid = this.siblingPaymentData.every(s => (s.paymentAmount || 0) >= 0);
        
        // Check if any sibling with payment amount > 0 has no invoices (totalAmountInvoiced < 0.01)
        const hasInvalidStudent = this.siblingPaymentData.some(s => 
            (s.paymentAmount > 0) && (s.totalAmountInvoiced < 0.01)
        );
        
        // Check required form fields
        const paymentModeValid = this.receivePmtFrom.get('paymentMode')?.valid || false;
        const chequeNumberValid = this.optionalDateControl 
            ? this.receivePmtFrom.get('chequeNumber')?.valid || false
            : true;
        
        
        return hasValidAmount && allValid && !hasInvalidStudent && paymentModeValid && chequeNumberValid;
    }

    /**
     * Overall payment validation - checks form, amount, and method-specific validations
     */
    isPaymentValid(): boolean {
        // Check basic form validity
        if (!this.receivePmtFrom.valid) {
            return false;
        }

        // Get receive method from form control to ensure sync
        const receiveMethod = this.receivePmtFrom.get('receiveMethod')?.value || this.receiveMethod;


        // For sibling custom payments - allow any positive custom amount
        if (this.hasSiblings && receiveMethod === 'custom') {
            const result = this.isSiblingPaymentValid();
            return result;
        }

        // For single child payments
        if (!this.hasSiblings) {
            const amount = this.receivePmtFrom.get('amount')?.value || 0;
            // Amount must be greater than 0
            if (amount <= 0) {
                return false;
            }
            
            // For custom method, allow any positive amount regardless of unpaid amount
            if (receiveMethod === 'custom') {
                return true;
            }
            
            // For max method, only allow if there's unpaid amount > 0
            if (receiveMethod === 'max') {
                // Check if balance amount is positive
                if (this.balanceAmount <= 0) {
                    return false;
                }
            }
            return true;
        }

        // For max method with siblings, ensure at least one sibling has unpaid amount > 0
        if (this.hasSiblings && receiveMethod === 'max') {
            const totalUnpaid = this.getTotalSiblingUnpaidAmount();
            if (totalUnpaid <= 0) {
                return false;
            }
        }

        return true;
    }

    /**
     * Handle receive method change
     */
    onReceiveMethodChange(method: 'max' | 'custom'): void {
        this.receiveMethod = method;
        
        // Ensure form control is also updated
        this.receivePmtFrom.patchValue({
            receiveMethod: method
        });
        
        if (method === 'max') {
            // Set amounts to max available
            if (this.config.data.isRefund) {
                if (this.hasSiblings) {
                    // Set each sibling's refund amount to their max
                    this.siblingRefundData.forEach(sibling => {
                        sibling.refundAmount = sibling.maxRefundAmount;
                    });
                } else {
                    // Set single amount to max refundable
                    this.receivePmtFrom.patchValue({
                        amount: this.totalRefundableAmount
                    });
                }
            } else {
                if (this.hasSiblings) {
                    // Set each sibling's payment amount to their unpaid amount
                    this.siblingPaymentData.forEach(sibling => {
                        sibling.paymentAmount = sibling.unpaidAmount;
                    });
                    
                    // For siblings in max mode, set amount field to total unpaid amount (for display)
                    const totalUnpaid = this.getTotalSiblingUnpaidAmount();
                    const amountControl = this.receivePmtFrom.get('amount');
                    amountControl?.clearValidators();
                    amountControl?.patchValue(totalUnpaid);
                    amountControl?.updateValueAndValidity();
                } else {
                    // Set single amount to unpaid amount
                    this.receivePmtFrom.patchValue({
                        amount: this.balanceAmount
                    });
                    
                    // Update validators for max method - no max limit
                    this.receivePmtFrom.get('amount')?.setValidators([
                        Validators.required,
                        Validators.min(0.01)
                    ]);
                    this.receivePmtFrom.get('amount')?.updateValueAndValidity();
                }
            }
        } else {
            // Custom - reset to 0
            if (this.config.data.isRefund) {
                if (this.hasSiblings) {
                    this.siblingRefundData.forEach(sibling => {
                        sibling.refundAmount = 0;
                    });
                } else {
                    this.receivePmtFrom.patchValue({
                        amount: 0
                    });
                }
            } else {
                if (this.hasSiblings) {
                    // For siblings in custom mode, reset amounts and clear the display field
                    this.siblingPaymentData.forEach(sibling => {
                        sibling.paymentAmount = 0;
                    });
                    
                    const amountControl = this.receivePmtFrom.get('amount');
                    amountControl?.clearValidators();
                    amountControl?.patchValue(0);
                    amountControl?.updateValueAndValidity();
                } else {
                    // Reset to 0 for custom amount
                    this.receivePmtFrom.patchValue({
                        amount: 0
                    });
                    
                    // Update validators for custom method - no max limit
                    this.receivePmtFrom.get('amount')?.setValidators([
                        Validators.required,
                        Validators.min(0.01)
                    ]);
                    this.receivePmtFrom.get('amount')?.updateValueAndValidity();
                }
            }
        }
    }
}
